<template>
    <div v-if="hasMounted">
        <h6 class="mb-2">Suppliers that will be updated</h6>

        <webix-ui :config="ui" v-model="suppliers_to_update"></webix-ui>
        <div id="suppliersToUpdateTablePaging"></div>
    </div>
</template>

<script>
import { suppliersComputed, suppliersMethods } from "@/state/helpers";

export default {
    components: {},
    data: () => ({
        hasMounted: false,
        resize_event: null,
        data: [
            { id: 1, company_name: "test 1", bbbee_level: 5, vat_no: "4567898", company_reg: "678/567/23" },
            { id: 2, company_name: "test 2", bbbee_level: 6, vat_no: "6677788", company_reg: "876/765/22" },
        ],
    }),
    computed: {
        ...suppliersComputed,
        ui() {
            //eslint-disable-next-line
            let el = this;

            let ui = {
                id: "suppliersToUpdateTable",
                view: "datatable",
                css: "datatableUsers webix_header_border webix_data_border datatableHover",
                autoheight: true,
                // hover: "datatableHover",
                // select: "cell",
                // hover: "suppliersTableHoverRow",

                minHeight: 60,
                minColumnWidth: 120,
                rowHeight: 35,
                scrollY: false,
                scrollX: true,
                resizeColumn: true,
                editable: true,

                // pager: {
                //     template: "{common.prev()} {common.pages()} {common.next()}",
                //     container: "suppliersToUpdateTablePaging",
                //     css: { width: "100% !important" },
                //     size: 5,
                //     group: 5,
                // },
                columns: [
                    {
                        id: "vat_no",
                        header: ["VAT No."],
                        fillspace: 1,
                    },
                    {
                        id: "company_reg",
                        header: ["Company Reg No."],
                        fillspace: 1,
                    },
                    {
                        id: "supplier_name",
                        header: ["New Name"],
                        tooltip: false,
                        // editor: "text",
                        fillspace: 1,
                    },
                    {
                        id: "current_supplier_name",
                        header: ["Old Name"],
                        tooltip: false,
                        // editor: "text",
                        fillspace: 1,
                    },
                    {
                        id: "supplier_no",
                        header: ["New Supplier No"],
                        fillspace: 1,
                    },
                    {
                        id: "current_supplier_no",
                        header: ["old Supplier No"],
                        fillspace: 1,
                    },
                    {
                        id: "contact_no",
                        header: ["New Contact No"],
                        fillspace: 1,
                    },
                    {
                        id: "current_contact_no",
                        header: ["Old Contact No"],
                        fillspace: 1,
                    },
                    {
                        id: "email",
                        header: ["New Email"],
                        fillspace: 1,
                    },
                    {
                        id: "current_email",
                        header: ["Old Email"],
                        fillspace: 1,
                    },
                    {
                        id: "address",
                        header: ["New Address"],
                        fillspace: 1,
                    },
                    {
                        id: "current_address",
                        header: ["Old Address"],
                        fillspace: 1,
                    },
                ],
                ready() {
                    // el.resize_event = window.webix.event(window, "resize", function() {
                    //     el.$nextTick(() => {
                    //         window.webix.$$(el.ui.id).refresh();
                    //     });
                    // });
                },
                on: {},

                onClick: {
                    //eslint-disable-next-line
                    qcAction: function(id, e, trg) {},
                    //eslint-disable-next-line
                    certificateListAction: function(id, e, trg) {},
                },
            };

            //pager
            if (this.suppliers_to_update.length > 15) {
                ui.pager = {
                    template: "{common.prev()} {common.pages()} {common.next()}",
                    container: "suppliersToUpdateTablePaging",
                    css: { width: "100% !important" },
                    size: 5,
                    group: 5,
                };
            }

            return ui;
        },
    },
    methods: {
        ...suppliersMethods,
    },
    mounted() {
        setTimeout(() => {
            this.hasMounted = true;
        }, 100);
    },
};
</script>

<style lang="scss">
.suppliersTableHoverRow {
    background: #f0dcb6;
    cursor: text;
}
</style>
